import { mapState } from 'vuex'
import { EsputnikService } from '@/services/AnalyticService'
import cookieHelper from '@/helpers/cookieHelper'

export const collectDataForEsputnik = {
  computed: {
    ...mapState({
      user: state => state.user.user_data
    }),
    userData () {
      let result = {
        datetime: Date.now()
      }
      const dataFromLocalStorage = JSON.parse(localStorage.getItem('userData') || '{}')
      if (dataFromLocalStorage) {
        if (dataFromLocalStorage.email) {
          result.user_email = dataFromLocalStorage.email
        }
        if (dataFromLocalStorage.phone) {
          result.user_phone = dataFromLocalStorage.phone
        }
        if (dataFromLocalStorage.name) {
          result.user_name = dataFromLocalStorage.name
        }
        if (dataFromLocalStorage.user_id) {
          result.externalCustomerId = dataFromLocalStorage.user_id
        }
      }
      if (this.user) {
        if (this.user.email) {
          result.user_email = this.user.email
        }
        if (this.user.phone) {
          result.user_phone = this.user.phone
        }
        if (this.user.name) {
          result.user_name = this.user.name
        }
        if (this.user.user_id) {
          result.externalCustomerId = this.user.user_id
        }
      }
      return result
    }
  },
  methods: {
    sendEsputnikAddToWishlist (Product) {
      EsputnikService.addToWishlist('AddToWishlist', {
        'GeneralInfo': {
          'eventName': 'AddToWishlist',
          'siteId': 'A2AE3F5',
          ...this.userData,
          'cookies': {
            'sc': cookieHelper.getCookie('sc') || ''
          }
        },
        'AddToWishlist': {
          Product
        }
      })
    }
  }
}
